import React from "react";
import btnBG from "../images/ScoreButtonBackground.png";

import { useNavigate } from "react-router-dom";
import ConvertTimeStamp from "../Utils/ConvertTimeStamp";
function ScoreDisplay(props) {
  let scoreDate = ConvertTimeStamp(props.scoreDate);
  var scoreDateArr = scoreDate.split("-");
  var navigate = useNavigate();
  function ShowScore() {
    var dateStr = props.scoreDate.toString();
    navigate(`/score/${dateStr}`);
  }
  return (
    <div className="ScoreItem">
      {scoreDateArr[0]}
      <br />
      {scoreDateArr[1]}
      <br />
      <div className="ScoreButton" onClick={ShowScore}>
        {props.paid ? <div className="tag">Paid</div> : <></>}
        <img src={btnBG} className="ScoreButtonImg" alt="btn" />
        <div className="ScoreLabel">{props.Score}</div>
      </div>
    </div>
  );
}

export default ScoreDisplay;
